<fab-header [appName]="title" navStyle="none">
  <span class="user-greeting">{{userName ? "Hello, " + userName : ""}}</span>
  <fab-theme-setting></fab-theme-setting>
</fab-header>
<router-outlet></router-outlet>
